module.exports = __webpack_public_path__ + "media/images/swifticons/weather-sunny-211589633c948a2a43bf697b32653267.svg";